import { Link } from "react-router-dom";
import {
  Callout,
  Figure,
  H2,
  H3,
  LI,
  P,
  Table,
  UL,
} from "../../components/blog/BlogTypography";

import fig1 from "../../assets/blog/q3-2026-ransomware-trends/fig1-q3-victims-over-time.png";
import fig2 from "../../assets/blog/q3-2026-ransomware-trends/fig2-q3-sector-distribution.png";
import fig3 from "../../assets/blog/q3-2026-ransomware-trends/fig3-top10-groups-global.png";
import fig4 from "../../assets/blog/q3-2026-ransomware-trends/fig4-top-countries.png";
import fig11 from "../../assets/blog/q3-2026-ransomware-trends/fig11-india-sector-distribution.png";
import fig12 from "../../assets/blog/q3-2026-ransomware-trends/fig12-india-top10-groups.png";
import fig13 from "../../assets/blog/q3-2026-ransomware-trends/fig13-india-monthly.png";

const SUMMARY_ROWS = [
  ["Claimed victims", "2,373", "2,942", "+24.0%"],
  ["Active groups", "89", "106", "+19.1%"],
  ["Countries hit", "107", "124", "+15.9%"],
  ["Sectors hit", "13", "13", "No change"],
  ["New groups first seen", "24", "34", "+41.7%"],
];
const SUMMARY_HEADERS = ["Metric", "Q2 2026", "Q3 2026", "Change"];

const INDIA_VICTIM_HEADERS = ["Date", "Victim", "Group", "Sector"];
const INDIA_VICTIM_ROWS = [
  ["2026-09-28", "Chem Process Systems Pvt. Ltd.", "Doommageddon", "Manufacturing"],
  ["2026-09-22", "vit.ac.in", "Auditteam", "Education"],
  ["2026-09-20", "Siddhi Green Excellence Pvt. Ltd", "Orova", "Energy & Utilities"],
  ["2026-09-15", "Indic", "Thegentlemen", "Technology"],
  ["2026-09-15", "BGR Energy Systems", "Thegentlemen", "Energy & Utilities"],
  ["2026-09-13", "vi***in", "Auditteam", "Transportation"],
  ["2026-09-13", "INCOR Group", "Doommageddon", "Other"],
  ["2026-09-12", "Nexbex Solutions Private Limited", "Emperador", "Unclassified"],
  ["2026-09-12", "swadeshicipl.com", "Krybit", "Manufacturing"],
  ["2026-09-12", "Praveg Caves Jawai", "Medusalocker", "Hospitality"],
  ["2026-09-10", "CO-OP URBAN BANK LTD", "Global Secret Group", "Financial Services"],
  ["2026-09-10", "i2k2 Networks", "Vexy Ransomware", "Technology"],
  ["2026-09-09", "Universal Starch-Chem Allied Ltd", "Emperador", "Manufacturing"],
  ["2026-09-07", "Soni Dwarkadas Virchand", "Thegentlemen", "Other"],
  ["2026-09-07", "United Group", "Vexy Ransomware", "Other"],
  ["2026-09-06", "Sancity", "Vexy Ransomware", "Other"],
  ["2026-09-04", "Palsana Enviro (PEPL)", "Vexy Ransomware", "Manufacturing"],
  ["2026-09-04", "Annapurna Fashion", "Vexy Ransomware", "Retail & E-Commerce"],
  ["2026-09-02", "part1.simplexengg.in", "Eclipse", "Technology"],
  ["2026-09-02", "Seasia Infotech", "Thegentlemen", "Technology"],
  ["2026-09-02", "Licindia", "Medusalocker", "Other"],
  ["2026-09-01", "seashellhospital.com", "Krybit", "Healthcare"],
  ["2026-09-01", "vedantaainstitute.in", "Krybit", "Education"],
  ["2026-09-01", "southsign.in", "Krybit", "Professional Services"],
  ["2026-08-31", "R L Fine Chem Pvt. Ltd.", "Global Secret Group", "Manufacturing"],
  ["2026-08-30", "G R Infraprojects", "Thegentlemen", "Manufacturing"],
  ["2026-08-26", "karkinos.in", "Krybit", "Healthcare"],
  ["2026-08-26", "jindallifescience.com", "Krybit", "Healthcare"],
  ["2026-08-26", "Simplex Engineering", "Eclipse", "Manufacturing"],
  ["2026-08-23", "AGS Cinemas", "Thegentlemen", "Hospitality"],
  ["2026-08-21", "Gindre India", "Qilin", "Manufacturing"],
  ["2026-08-20", "The University of Delhi (DU)", "Dysphor1a", "Education"],
  ["2026-08-16", "BONJOUR GROUP", "Majinahanashi", "Other"],
  ["2026-08-15", "DodoPayments", "Direwolf", "Financial Services"],
  ["2026-08-15", "www.shalina.com", "Blackwater", "Unclassified"],
  ["2026-08-12", "QCPL.IN", "Clop", "Manufacturing"],
  ["2026-08-12", "9ALTITUDES.COM", "Clop", "Technology"],
  ["2026-08-12", "ATOMBERG.COM", "Clop", "Manufacturing"],
  ["2026-08-12", "JPMGROUP.CO.IN", "Clop", "Financial Services"],
  ["2026-08-12", "labindia.com", "Krybit", "Healthcare"],
  ["2026-08-10", "DECK APP TECHNOLOGIES PTE. LTD", "Unsafe", "Technology"],
  ["2026-08-10", "RAK Construction", "Thegentlemen", "Manufacturing"],
  ["2026-08-10", "Lancesoft India", "Thegentlemen", "Technology"],
  ["2026-08-07", "ATMS", "Incransom", "Transportation"],
  ["2026-08-07", "ratnasagar.com", "L Group", "Unclassified"],
  ["2026-08-05", "udhaiyamdhall.com", "Orion", "Retail & E-Commerce"],
  ["2026-08-05", "Nitrex Chemicals India", "Orion", "Manufacturing"],
  ["2026-08-05", "Greenbotz", "Everest", "Technology"],
  ["2026-08-05", "Aptara", "Everest", "Professional Services"],
  ["2026-08-05", "Powerweave", "Everest", "Manufacturing"],
  ["2026-08-03", "pcclimitedindia.com", "Lockbit5", "Manufacturing"],
  ["2026-07-30", "Delkart Industries Pvt", "Thegentlemen", "Manufacturing"],
  ["2026-07-30", "ETA Technology Pvt", "Thegentlemen", "Technology"],
  ["2026-07-30", "Kontact Consortium India Pvt", "Thegentlemen", "Other"],
  ["2026-07-30", "Indus Protech Solutions", "Thegentlemen", "Technology"],
  ["2026-07-27", "K. Venkatesh, Co", "Nightspire", "Unclassified"],
  ["2026-07-27", "Wings Argo Private Limited", "Nightspire", "Other"],
  ["2026-07-26", "Hinduja Tech | BMW Group & Škoda Auto", "Global Secret Group", "Manufacturing"],
  ["2026-07-26", "Cipher Dynamics", "Global Secret Group", "Technology"],
  ["2026-07-25", "Principle Diagnostics Laboratory", "Qilin", "Healthcare"],
  ["2026-07-24", "Jiva Health", "Unsafe", "Healthcare"],
  ["2026-07-24", "Bank of Baroda (bankofbaroda.bank.in)", "Triple X", "Financial Services"],
  ["2026-07-23", "origins ivf", "Killsec", "Healthcare"],
  ["2026-07-23", "Tikona Infinet", "Thegentlemen", "Technology"],
  ["2026-07-23", "DayNDay", "Thegentlemen", "Other"],
  ["2026-07-22", "dhli.in", "Krybit", "Unclassified"],
  ["2026-07-22", "Vibonum Technologies Private Limited", "Krybit", "Technology"],
  ["2026-07-21", "Pertinent Healthcare Business Solutions Private Limited", "Titan", "Healthcare"],
  ["2026-07-14", "Omax Autos", "Dragonforce", "Manufacturing"],
  ["2026-07-13", "Webosphere", "Nightspire", "Technology"],
  ["2026-07-10", "Abhay Prabhavana", "Deadlock", "Other"],
  ["2026-07-07", "CSIR Structural Engineering Research Centre", "Thegentlemen", "Government & Defense"],
  ["2026-07-06", "Hansa Research Group Pvt. Ltd", "Morpheus", "Professional Services"],
  ["2026-07-06", "Innovano", "Doommageddon", "Technology"],
  ["2026-07-01", "CTM India Limited (Motherson)", "Thegentlemen", "Manufacturing"],
];

export default function Q3RansomwareTrends() {
  return (
    <>
      <Callout>
        CyberMon Digital Risk Intelligence (DRI) Threat Research. Analysis window: Q3 2026 (1
        July–30 September), compared against Q2 2026. A "victim" here is a publicly observed
        ransomware/extortion claim — it does not independently prove encryption, payment, or the
        full scope of compromise. Claim dates reflect observed disclosure timing and may differ
        from intrusion dates; group counts may include rebrands, splinters or affiliate-driven
        operations.
      </Callout>

      <H2>Executive Summary</H2>
      <P>
        Q3 2026 marked a material acceleration in public ransomware victims. CyberMon DRI
        telemetry recorded 2,942 victims, up from 2,373 in Q2, while the number of active groups
        increased from 89 to 106. That represents a 24.0% quarter-over-quarter increase in victims
        and a 19.1% increase in active groups.
      </P>
      <P>
        The quarter was not simply busier; it was more fragmented. Thirty-four groups were first
        observed during Q3 versus 24 in Q2. Manufacturing became the largest affected sector in
        Q3, while Technology, Healthcare and Financial Services all expanded meaningfully. The
        United States remained the dominant geography by a wide margin.
      </P>
      <P>
        India deserves specific attention. The Q3 India dataset contains 75 ransomware victims
        explicitly geolocated to India across the full quarter: 24 in July, 27 in August and 24 in
        September. Manufacturing leads with 18 victims, followed by Technology with 15. TheGentlemen
        is the most active group in the India dataset with 16 victims, followed by Krybit with 9
        and Vexy Ransomware with 5.
      </P>
      <Table headers={SUMMARY_HEADERS} rows={SUMMARY_ROWS} />

      <H2>1. Q3 2026: The Quarter in View</H2>
      <P>
        Ransomware victim count rose sharply through July and reached its strongest weekly level
        in early August, approaching 300 victims worldwide in a week. Activity then moderated
        through late August and early September, rebounded around mid-September, and declined
        again at quarter-end. The pattern suggests multiple overlapping campaigns rather than a
        single sustained spike.
      </P>
      <Figure
        src={fig1}
        alt="Line chart of Q3 2026 global ransomware victim counts by week, rising from about 130 in late June to a peak near 300 in early August, dipping and rebounding through late August and September, then declining to about 110 by the end of September."
        caption="Figure 1. Q3 victim count over time (CyberMon DRI telemetry)."
      />

      <H3>Sector exposure shifted toward manufacturing</H3>
      <P>
        Manufacturing led Q3 with 480 victims, followed by Professional Services (407), Technology
        (372), Healthcare (281) and Retail & E-Commerce (199). Financial Services recorded 154
        victims. Compared with Q2, Manufacturing rose from 394 to 480 (+21.8%), Technology from
        260 to 372 (+43.1%), Healthcare from 204 to 281 (+37.7%), and Financial Services from 107
        to 154 (+43.9%). Professional Services moved in the opposite direction, falling from 519
        to 407 (-21.6%).
      </P>
      <Figure
        src={fig2}
        alt="Donut chart of Q3 2026 global sector distribution: Manufacturing and Professional Services are the two largest slices, followed by Technology, Healthcare, Other, Retail & E-Commerce, Financial Services, Transportation, Agriculture and Food Production, and Government & Defense."
        caption="Figure 2. Q3 sector distribution."
      />

      <H3>Actor concentration remained high despite ecosystem fragmentation</H3>
      <P>
        The top-group view shows TheGentlemen and Qilin far ahead of most peers, with Incransom,
        Krybit, LockBit5, Akira, Storm, SafePay, DragonForce and Direwolf forming the next tier.
        The important strategic signal is the coexistence of a few high-volume operators with a
        long tail of newly appearing brands.
      </P>
      <Figure
        src={fig3}
        alt="Horizontal bar chart of the top 10 ransomware groups by Q3 2026 victim count: thegentlemen leads with about 395, followed by qilin around 365, incransom, krybit, Deadlock, akira, Storm, safepay, dragonforce and direwolf each in a lower tier between roughly 55 and 115."
        caption="Figure 3. Top 10 ransomware groups by Q3 victim count."
      />

      <H3>Geography: the US remains the centre of ransomware activity</H3>
      <P>
        The United States remained the most heavily represented country by a substantial margin.
        Germany, the United Kingdom, Italy, Canada and Brazil formed the next tier, while India
        also appears among the leading countries in the quarter's geographic distribution. Of
        2,942 Q3 victims, 2,714 were geolocated in the telemetry.
      </P>
      <Figure
        src={fig4}
        alt="Horizontal bar chart of top countries in Q3 2026 by ransomware victim count: the US leads with close to 1,000, followed by a second tier of DE, GB, IT, CA, BR and IN roughly in the 70-160 range, then FR, MX, ES, AR, AU, TR, CH and JP each below 60."
        caption="Figure 4. Top countries in Q3."
      />

      <H2>2. Q3 vs Q2: What Changed?</H2>
      <P>
        The Q2-to-Q3 comparison points to both scale and diversification. Victim count increased
        by 569 victims, while 17 additional groups became active. The count of countries affected
        rose by 17, but the number of represented sectors remained unchanged at 13 — indicating
        broader geographic and actor expansion rather than expansion into entirely new industry
        categories.
      </P>
      <P>
        Q2 was led by Professional Services (519), Manufacturing (394), Technology (260), Retail &
        E-Commerce (212) and Healthcare (204). By Q3, Manufacturing had moved into first place and
        Technology and Healthcare had grown substantially, while Professional Services declined.
      </P>
      <P>
        At the actor level, Qilin led Q2, followed by TheGentlemen and DragonForce. In Q3,
        TheGentlemen moved to the top position, Qilin remained a dominant operator, and
        newer/high-growth names such as Krybit and Storm became more visible.
      </P>

      <H2>3. New and Emerging Ransomware Groups</H2>
      <P>
        CyberMon DRI telemetry identified 34 ransomware brands first seen during Q3, compared with
        24 in Q2. The Q3 cohort included Doommageddon, Booba Project, CRPxO, Global Secret Group,
        ExfilSquad, Orova, Panzer, Dark Project, L Group, Storm, Emperador, Vexy Ransomware, N0n,
        EndZone and others. The large number of first-seen brands reinforces a recurring challenge
        for defenders: brand churn can outpace traditional static blocklists and reputation-based
        monitoring.
      </P>
      <P>
        Storm stands out within the first-seen Q3 cohort with 76 victims in the quarter's
        telemetry. Global Secret Group recorded 48, Orova 47, CRPxO 37, Panzer 35, Emperador 32
        and Dark Project 30. These counts show that a newly observed brand can establish
        meaningful victim volume quickly.
      </P>
      <Callout>
        <strong>Vexy Ransomware warrants particular attention.</strong> It was first observed on 3
        September 2026 and was associated with 17 victims in the Q3 telemetry. CyberMon previously
        published a dedicated threat-intelligence analysis of the group, including its RaaS
        positioning and India-heavy victim profile:{" "}
        <Link to="/blog/vexy-ransomware-raas-threat-intelligence" className="text-primary underline hover:no-underline">
          Vexy Ransomware: Inside an Emerging RaaS Operation's Affiliate Pitch and India-Heavy Victim List
        </Link>
        .
      </Callout>

      <H2>4. India Focus</H2>
      <P>The India-specific dataset contains 75 victims across the full quarter.</P>

      <H3>India sector profile</H3>
      <P>
        Manufacturing is the largest sector in the India dataset with 18 victims (24.0%), followed
        by Technology with 15 (20.0%). Other activity accounts for 10 victims (13.3%), Healthcare
        for 8 (10.7%), Unclassified for 5 (6.7%) and Financial Services for 4 (5.3%). Education and
        Professional Services record 3 victims each, while Energy & Utilities, Transportation,
        Hospitality and Retail & E-Commerce record 2 each; Government & Defense records 1.
      </P>
      <Figure
        src={fig11}
        alt="Pie chart of India Q3 2026 ransomware claims by sector (n=75): Manufacturing 24%, Technology 20%, Other 13%, Healthcare 11%, Unclassified 7%, Financial Services 5%, Education 4%, Professional Services 4%, and smaller slices for Energy & Utilities, Transportation, Hospitality, Retail & E-Commerce and Government & Defense."
        caption="Figure 11. India Q3 sector distribution."
      />

      <H3>Top ransomware groups targeting India</H3>
      <P>
        TheGentlemen leads India-focused ransomware activity with 16 victims (21.3%), followed by
        Krybit with 9 (12.0%) and Vexy Ransomware with 5 (6.7%). Global Secret Group and Clop
        record 4 victims each, while Doommageddon, Everest and Nightspire record 3 each. Vexy's
        position remains notable because it was first observed during Q3 yet already ranks third
        in the India dataset.
      </P>
      <Figure
        src={fig12}
        alt="Horizontal bar chart of the top 10 ransomware groups by India victim count in Q3 2026: Thegentlemen leads with 16, Krybit 9, Vexy Ransomware 5, Global Secret Group 4, Clop 4, Doommageddon 3, Everest 3, Nightspire 3, Auditteam 2, Emperador 2."
        caption="Figure 12. Top 10 ransomware groups associated with India victims in Q3 2026."
      />

      <H3>Month-wise India listings</H3>
      <P>
        India-focused ransomware activity was remarkably even across Q3: July recorded 24 victims,
        August 27 and September 24. August was the quarter's highest month, but only marginally,
        suggesting sustained rather than isolated ransomware pressure on Indian organisations.
      </P>
      <Figure
        src={fig13}
        alt="Bar chart of India ransomware victim claims by month in Q3 2026: July 24, August 27, September 24."
        caption="Figure 13. India ransomware victim count by month in Q3 2026."
      />

      <H3>India ransomware victim claims list, Q3</H3>
      <P>
        The full list of India-geolocated claims observed in Q3, as captured in CyberMon DRI
        telemetry. Entries are publicly observed leak-site or extortion claims; inclusion here does
        not independently confirm that a listed organisation was compromised, nor the scope of any
        compromise.
      </P>
      <Table headers={INDIA_VICTIM_HEADERS} rows={INDIA_VICTIM_ROWS} />

      <H2>5. What the Q3 Trend Means for Defenders</H2>
      <UL>
        <LI>
          <strong>External exposure needs continuous monitoring.</strong> The combination of
          higher victim volume and more active groups increases the probability that exposed
          internet-facing assets, leaked credentials and forgotten infrastructure are discovered
          and operationalised by different actors.
        </LI>
        <LI>
          <strong>Actor-name monitoring alone is insufficient.</strong> Thirty-four first-seen
          brands in one quarter means defenders should track infrastructure, victimology,
          credential exposure, initial-access patterns and leak-site activity — not only known
          ransomware names.
        </LI>
        <LI>
          <strong>Manufacturing and technology require heightened attention.</strong> Both sectors
          increased materially from Q2 to Q3, and manufacturing became the largest sector in the
          quarter.
        </LI>
        <LI>
          <strong>India-focused intelligence should be treated as a dedicated lens.</strong> The
          visible India victim list spans manufacturing, technology, education, energy, finance,
          healthcare and other sectors, with both established and newly observed groups
          represented.
        </LI>
      </UL>

      <H2>Methodology and Caveats</H2>
      <P>
        This report analyses CyberMon DRI ransomware claim telemetry captured for Q2 and Q3 2026.
        A "victim" is a publicly observed ransomware/extortion claim; it does not independently
        prove encryption, payment, or the full scope of compromise. Claim dates represent observed
        disclosure timing and may differ from intrusion dates. Group counts reflect names/brands
        present in the telemetry and may include rebrands, splinters or affiliate-driven
        operations.
      </P>
    </>
  );
}
